<template>
  <div style="width:130px">
    <v-select
      class="pa-0 ma-0"
      v-model="language"
      item-text="label"
      item-value="value"
      :items="items"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: `Language`,
  data() {
    return {
      items: [
        { label: "Inglés (en)", value: "en" },
        { label: "Español (es)", value: "es" },
        { label: "Frances (fr)", value: "fr" }
      ]
    };
  },
  computed: {
    language: {
      set(value) {
        this.$store.dispatch("setLanguage", value);
      },
      get() {
        return this.$store.getters.language;
      }
    }
  }
};
</script>
